"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdRecaptchaSiteKeysEnum = void 0;
var TpdRecaptchaSiteKeysEnum;
(function (TpdRecaptchaSiteKeysEnum) {
    TpdRecaptchaSiteKeysEnum["INVISIBLE_KEY_NO_PROD"] = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
    TpdRecaptchaSiteKeysEnum["INVISIBLE_KEY"] = "6LeIu8QUAAAAAA6mU3kLSlsrhRAguUHsV6QB_NDx";
    TpdRecaptchaSiteKeysEnum["NORMAL_KEY"] = "6LetKiQUAAAAAJBx6f4aYnDOYQWiEPJn63BJejsn";
})(TpdRecaptchaSiteKeysEnum = exports.TpdRecaptchaSiteKeysEnum || (exports.TpdRecaptchaSiteKeysEnum = {}));
